import { Row as CompRow } from 'src/components/atoms/Row';
import styled from 'styled-components';

export const StyledContainer = styled(CompRow)`
  padding: 1rem 2rem;
  min-width: 20.625rem;
  display: flex;
  justify-content: space-between;
  @media ${({ theme }) => theme.device.tablet} {
    justify-content: flex-start;
    flex-direction: column;
  }
`;

export const StyledDiv = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-right: 1rem;
  margin-left: 1rem;
`;

export const FiltersContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-bottom: 1rem;
`;

export const RowCenter = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
`;

export const Col = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ColText = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
`;
